<script>
  import {getNavigation} from "../api/navigation";

  import {onMount} from "svelte";

  export let showMenu;
  let navigationElements = [];

  onMount(async() => {
    try {
      navigationElements = await getNavigation("nav");
    } catch(error) {
      console.error(error);
    }
  });

  function handleAnchorClick(event) {
    event.preventDefault();
    const link     = event.currentTarget;
    const anchorId = new URL(link.href).hash.replace("#", "");
    const anchor   = document.getElementById(anchorId);
    window.scrollTo({
                      top:      anchor.offsetTop,
                      behavior: "smooth"
                    });
  }
</script>

<nav class="container-fluid pt-3">
    <div class="row d-flex align-items-center">
        <div class="col-2 mt-3 mt-md-1 offset-md-1">
            <a href="https://umarlestatuty.pl">
                <img
                        class="nav--logo"
                        src="./images/logo.png"
                        alt="Stowarzyszenie Umarłych Statutów"
                />
            </a>
        </div>

        <ul class="nav--elements col-12 col-md-6 mt-3 {showMenu ? 'd-none' : ''}">
            {#each navigationElements as {anchor, label}}
                <li>
                    <a href={anchor} on:click={handleAnchorClick}>{label.toUpperCase()}</a>
                </li>
            {/each}
        </ul>
    </div>
</nav>

<style>
    nav {
        background-color: white;
        width: 100%;
    }

    .nav--logo {
        max-height: 49px;
        width: auto;
    }

    .nav--elements {
        display: flex;
        justify-content: space-around;
        list-style: none;
    }

    .nav--elements li a {
        font-family: "Montserrat", sans-serif;
        font-weight: 600;
        font-size: 12px;
        color: #425466;
        text-decoration: none;
    }
</style>
